




































































































































































































import "./review.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import ObjectiveCard from "../components/reviews/objective-card.vue";
import ObjectiveSetup from "../components/reviews/objective-setup.vue";
import ObjectiveCopy from "../components/reviews/objective-copy.vue";
import TrackingFilter from "../components/reviews/tracking-filter.vue";
import ReviewReportCard from "../components/reviews/review-report-card.vue";
import MemberList from "../components/reviews/member-list.vue";
import AssignmentList from "../components/reviews/assignments/assignment-list.vue";
import AssignmentTrackerFilter from "../components/reviews/assignments/assignment-tracker-filter.vue";
import VideoPlayer from "../components/video-player/video-player.vue";
import BottomNavigation from "../components/common/bottom-navigation/bottom-navigation.vue";
import BottomNavigationItem from "../components/common/bottom-navigation/bottom-navigation-item.vue";
import ResizableTextarea from "../components/common/ResizableTextarea.js";
import ReviewSetup from "../components/reviews/review-setup.vue";

export default Vue.extend({
  components: {
    ObjectiveCard,
    ObjectiveSetup,
    ObjectiveCopy,
    MemberList,
    TrackingFilter,
    AssignmentList,
    "assignment-tracking-filter": AssignmentTrackerFilter,
    VideoPlayer,
    ReviewReportCard,
    BottomNavigation,
    BottomNavigationItem,
    ResizableTextarea,
    ReviewSetup,
  },
  props: {
    id: String,
  },
  data() {
    return {
      isCollapsed: false,
      hoverCollapseToggled: false,
      lastMenuItemName: "dashboard",
      currentMenuItemName: "dashboard",
      showReviewSetup: false,
      edittingReview: {
        id: null,
        name: null,
        scope: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: null,
        description: null,
        members: [],
        hashTags: null,
        teamworkOption: NaN,
        editRole: NaN,
        calculationOption: NaN,
        gradingOption: NaN,
        parentRoleName: null,
        childRoleName: null,
        grantedPermissions: [],
        gradeModel: null,
        completed: false,
        teams: [],
      },
      showQuickEditor: false,
      quickEdittingObjective: null,
      quickEdittingObjectiveName: "",
      quickEditorStyles: {},
      showObjectiveCreatorOld: false,
      showObjectiveSetup: false,
      showObjectiveCopy: false,
      showDelete: false,
      copyingObjective: null,
      edittingObjective: {
        id: null,
        name: null,
        timeline: null,
        priority: NaN,
        maxPriority: NaN,
        description: null,
        trackingQuestion: null,
        measurementUnit: null,
        targetType: 1,
        inputOptions: null,
        trackingTarget: null,
        checkinDates: null,
        checkinTime: "09:00",
        cronExcludedDates: [],
        cronExpression: null,
        cronStartDate: null,
        cronEndDate: null,
        attachments: [],
        reviewId: null,
      },
      currentObjectiveId: null,
      deleteElement: null,
      checkpoints: [],
      trackColumns: [],
      trackData: [],
      currentTrackerId: null,
      reportCardValueFormat: "both",
      viewType: null,
      showVideoPlayer: false,
      videoUrl: "",
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111-111-1111,
    };
  },
  computed: {
    ...mapState("review", ["currentReview", "loading", "currentActionTrackingInformation", "currentReviewHasCheckpointUpdated"]),
    ...mapGetters("review", ["canEditCurrentReview", "parentRoleTitle", "childRoleTitle", "currentReviewGrades"]),
    ...mapState("session", ["user"]),
    allObjectives(): any {
      let objectives = (this as any).currentReview ? (this as any).currentReview.objectives || [] : [];
      return objectives.sort((a, b) => {
        return a.priority === b.priority ? 0 : a.priority > b.priority ? 1 : -1;
      });
    },
    notStartedObjectives(): any {
      return this.allObjectives ? this.allObjectives.filter((objective) => isNaN(objective.trackingResult)) : [];
    },
    gradedLists() {
      let context = this as any;
      let lists = (this as any).currentReviewGrades.map((grade, index, grades) => {
        return {
          title: grade.name,
          color: grade.color,
          from: grade.from,
          to: index < grades.length - 1 ? grades[index + 1].from : NaN,
          objectives: [],
        };
      });

      lists.forEach((list) => {
        list.objectives = context.allObjectives.filter((objective) => objective.trackingResult * 100 >= list.from && (isNaN(list.to) ? true : objective.trackingResult * 100 < list.to));
      });

      return lists;
    },
    reviewForAssignmentsAndReport() {
      let currentReview = (this as any).currentReview;
      return currentReview && {}.toString.call(currentReview) === "[object Function]" ? null : currentReview;
    },
    menuitemClasses: function () {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
  },
  watch: {
    id(value) {
      this.loadReview();
    },
    user(newValue) {
      if (newValue) {
        (this as any).selectedMemberId = newValue.id;
 
        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  mounted() {
    let context = this as any;

    context.loadReview().then(() => {
      let tab = context.$route.query.tab;
      if (tab) {
        context.handleMenuSelect(tab);
      }
    });

    abp.event.on("abp.notifications.received", context.handleNotificationReceived);
  },
  created() {
    (this as any).$store.dispatch("review/setTargetUserFilter", "0");
  },
  beforeDestroy() {
    let context = this as any;
    console.log("leave page");
    abp.event.off("abp.notifications.received", context.handleNotificationReceived);
  },
  methods: {
    handleMenuSelect(name) {
      this.currentMenuItemName = name;
      //this.$store.dispatch("review/setActiveMenu", name);

      if (name === "checkins") {
        this.handleRefreshAssignments();
      }

      this.lastMenuItemName = name;
    },
    loadReview() {
      let context = this as any;
      return this.$store.dispatch("review/get", { id: context.id }).then((response) => {
        context.handleReportCardFilter();
      });
    },
    handleNotificationReceived(userNotification) {
      console.log(userNotification);
      if (userNotification.notification.entityId === this.id && userNotification.notification.data.version > (this as any).currentReview.contentVersion) {
        this.loadReview();
      }
    },
    handleMenuItemClick(name) {
      let context = this as any;
      switch (name) {
        case "editReview":
          context.handleOpenReviewEditor(context.currentReview);
          break;
      }
    },
    handleOpenReviewEditor(review) {
      let startDate = review.startDate ? new Date(review.startDate) : null;
      let endDate = review.endDate ? new Date(review.endDate) : null;

      this.edittingReview = {
        id: review.id,
        name: review.name,
        scope: review.scope,
        timezoneOffset: review.timezoneOffset,
        timezoneName: review.timezoneName,
        timeline: [startDate, endDate],
        description: review.description,
        members: review.members,
        hashTags: review.hashTags,
        teamworkOption: review.teamworkOption,
        editRole: review.editRole,
        calculationOption: review.calculationOption,
        gradingOption: review.gradingOption,
        parentRoleName: review.parentRoleName,
        childRoleName: review.childRoleName,
        grantedPermissions: review.grantedPermissions,
        gradeModel: review.gradeModel,
        completed: review.completed,
        teams: review.teams,
      };

      this.showReviewSetup = true;
    },
    handleCancelNewReview() {
      this.showReviewSetup = false;
    },
    handleNewObjective() {
      let review = (this as any).currentReview;
      let startDate = review.startDate ? new Date(review.startDate) : null;
      let endDate = review.endDate ? new Date(review.endDate) : null;
      let maxPriority = (this as any).allObjectives.length + 1;

      this.edittingObjective = {
        id: null,
        name: null,
        timeline: [startDate, endDate],
        priority: maxPriority,
        maxPriority: maxPriority,
        description: null,
        trackingQuestion: null,
        measurementUnit: null,
        targetType: null,
        inputOptions: '[{"label":"","placeholder":"Example: Yes","value":100},{"label":"","placeholder":"Example: No","value":0}]',
        trackingTarget: null,
        checkinDates: null,
        checkinTime: "09:00",
        cronExcludedDates: [],
        cronExpression: null,
        cronStartDate: null,
        cronEndDate: null,
        attachments: [],
        reviewId: (this as any).currentReview.id,
      };
      this.showObjectiveSetup = true;
    },
    handleCancelNewObjective() {
      this.showObjectiveSetup = false;
    },
    handleCardClick(objective, e) {
      this.quickEdittingObjective = objective;
      this.quickEdittingObjective.attachmentsForView = objective.attachments ? JSON.parse(objective.attachments) : [];
      this.getQuickEditorPosition(e.target.parentElement);
      this.showQuickEditor = true;
    },
    saveQuickEdittingObjective() {
      let context = this;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      context.$store
        .dispatch("review/upsertObjective", { data: context.quickEdittingObjective })
        .then((response) => {
          this.showQuickEditor = false;
        })
        .finally(() => {
          target.disabled = false;
        });
    },
    getQuickEditorPosition(element) {
      let offsetLeft = 0;
      let offsetTop = 0;
      do {
        if (!isNaN(element.offsetLeft)) {
          offsetLeft += element.offsetLeft - element.scrollLeft;
          offsetTop += element.offsetTop - element.scrollTop;
        }
      } while ((element = element.offsetParent));

      if (offsetLeft < 0) {
        offsetLeft = 0;
      }

      if (offsetTop < 0) {
        offsetTop = 0;
      }

      this.quickEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };
    },
    handleObjectiveEdit(objective, id) {
      if (!objective && id) {
        const objectives = (this as any).currentReview.objectives || [];
        objective = objectives.find((o) => o.id === id);
      }

      let startDate = objective.startDate ? new Date(objective.startDate) : null;
      let endDate = objective.endDate ? new Date(objective.endDate) : null;

      let checkinDates = [];
      if (objective.checkinDates) {
        checkinDates = (objective.checkinDates as string).split(";").map((dateString) => {
          let values = dateString.split(",");
          return { date: values[0], target: values[1] };
        });
      }

      let maxPriority = (this as any).allObjectives.length;
      this.edittingObjective = {
        id: objective.id,
        name: objective.name,
        timeline: [startDate, endDate],
        priority: objective.priority,
        maxPriority: maxPriority,
        description: objective.description,
        trackingQuestion: objective.trackingQuestion,
        measurementUnit: objective.measurementUnit,
        targetType: objective.targetType,
        inputOptions: objective.inputOptions,
        trackingTarget: objective.trackingTarget,
        checkinDates: checkinDates,
        checkinTime: objective.checkinTime,
        cronExcludedDates: objective.cronExcludedDates,
        cronExpression: objective.cronExpression,
        cronStartDate: objective.cronStartDate,
        cronEndDate: objective.cronEndDate,
        attachments: objective.attachments ? JSON.parse(objective.attachments) : [],
        reviewId: objective.reviewId,
      };

      this.showQuickEditor = false;
      this.showObjectiveSetup = true;
    },
    handleObjectiveCopy(objective) {
      this.copyingObjective = {
        id: objective.id,
        name: objective.name,
        description: objective.description,
        reviewId: objective.reviewId,
      };

      this.showQuickEditor = false;
      this.showObjectiveCopy = true;
    },
    handleCancelObjectiveCopy() {
      this.showObjectiveCopy = false;
    },
    showDeleteDialog(element) {
      this.deleteElement = element;

      this.showQuickEditor = false;
      this.showDelete = true;
    },
    handleDelete() {
      let context = this;
      this.$store.dispatch("review/deleteObjective", { data: this.deleteElement }).then((response) => {
        this.showDelete = false;
      });
    },
    getToValue(grades, index) {
      if (index + 1 < grades.length) {
        return grades[index + 1].from - 1;
      } else {
        return 100;
      }
    },
    handleTrackingFilter(filter) {
      var context = this as any;
      context.handleReportCardFilter();
    },
    handleValueFormatChanged(valueFormat) {
      var context = this as any;
      context.reportCardValueFormat = valueFormat;
    },
    handleAssignmentTrackingFilter(filter) {
      var context = this as any;
      context.viewType = filter.viewType;
      context.currentTrackerId = filter.trackerId;
    },
    handleReportCardFilter(filter) {
      (this as any).$refs.ReportCard.refreshReportData();
    },
    handleRefreshAssignments() {
      var context = this as any;
      context.$refs.OpenAssignments.refresh(context.currentTrackerId);
      context.$refs.CompletedAssignments.refresh(context.currentTrackerId);
    },
    handleVideoClick(type, url) {
      this.videoUrl = url;
      this.showVideoPlayer = true;
    },
    memberRoleNameResolver(memberId) {
      let members = (this as any).currentReview ? (this as any).currentReview.members.filter((m) => m.memberId == memberId) : [];
      if (members.length === 1) {
        let member = members[0];
        return member.role == 1 ? (this as any).currentReview.parentRoleName : member.role == 2 ? (this as any).currentReview.childRoleName : "";
      } else {
        return "";
      }
    },
  },
});
